

export { DatePicker } from './src/date-picker-view';
